import {
    GET_REQUEST,
    GET_REQUESTS,
    GET_EMPLOYEE_REQUESTS,
    DELETE_REQUEST,
    CREATE_REQUEST,
} from "../actionTypes";
import { bindActionCreators } from "redux";

const defaultState = {
    request: {},
    requests: [],
    employeeRequests: [],
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case GET_REQUEST:
            return {
                ...state,
                request: action.payload || defaultState.request,
            };
        case GET_REQUESTS:
            return {
                ...state,
                requests: action.payload || defaultState.requests,
            };
        case GET_EMPLOYEE_REQUESTS:
            return {
                employeeRequests:
                    action.payload || defaultState.employeeRequests,
            };
        case CREATE_REQUEST:
            return {
                ...state,
                requests: action.payload || defaultState.request,
            };
        default:
            return state;
    }
};
